
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/diversity-and-inclusion/programme-one",
      function () {
        return require("private-next-pages/about-us/diversity-and-inclusion/programme-one/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/diversity-and-inclusion/programme-one"])
      });
    }
  